import type {
  Email,
  Fax,
  Phone,
  PointOfContact,
} from '@festina/legalentity-general-types/legalentity'
import { typeUtils, type ValidatedKey } from '@festina-life/core'
import {
  FormikCheckbox,
  FormikSelect,
  FormikTextInput,
} from '@festina-life/ui/formikForms'
import { useTranslate, useTranslateEnum } from '@festina-life/ui/hooks'
import { useField } from 'formik'

type Props = {
  fieldNamePrefix: ValidatedKey
}

const pointOfContactTypes: PointOfContact['_type'][] = [
  'Email',
  'Fax',
  'Phone',
] satisfies [Email['_type'], Fax['_type'], Phone['_type']]

export const PointOfContactFields = ({ fieldNamePrefix }: Props) => {
  const translate = useTranslate()
  const translateEnum = useTranslateEnum()
  const validateKey =
    typeUtils.createNestedValidator<PointOfContact>(fieldNamePrefix)

  const [{ value: pointOfContactType }] = useField(validateKey('_type'))

  const validateEmailKey =
    typeUtils.createNestedValidator<Email>(fieldNamePrefix)
  const validateFaxKey = typeUtils.createNestedValidator<Fax>(fieldNamePrefix)
  const validatePhoneKey =
    typeUtils.createNestedValidator<Phone>(fieldNamePrefix)

  return (
    <>
      <FormikSelect
        name={validateKey('_type')}
        label={translate('pointOfContact.field.type')}
        options={pointOfContactTypes}
        renderFn={(x) => translateEnum('pointOfContact.enum.type', x)}
        isRequired
      />
      {pointOfContactType === 'Email' && (
        <FormikTextInput
          isRequired
          name={validateEmailKey('email')}
          label={translate('pointOfContact.field.email')}
        />
      )}
      {pointOfContactType === 'Fax' && (
        <FormikTextInput
          isRequired
          name={validateFaxKey('fax')}
          label={translate('pointOfContact.field.fax')}
        />
      )}
      {pointOfContactType === 'Phone' && (
        <FormikTextInput
          isRequired
          name={validatePhoneKey('phone')}
          label={translate('pointOfContact.field.phone')}
        />
      )}
      <FormikCheckbox
        name={validateKey('isValid')}
        label={translate('pointOfContact.field.isValid')}
      />
    </>
  )
}
